import React from "react";

function AutomaticOrder() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" x="0" y="0">
      <g transform="matrix(1.7500000000000007,0,0,2.0000000000000007,0,0)">
        <path
          fill="#ff9751"
          d="M1.322.53a.797.797 0 0 0-.793.792v7.674c0 .436.358.793.793.793h8.733a.796.796 0 0 0 .792-.793V1.322a.797.797 0 0 0-.792-.793z"
          data-original="#ff9751"
        />
        <path
          fill="#ff7f29"
          d="M10.281.566a.776.776 0 0 1 .037.227v7.674a.796.796 0 0 1-.792.793H.793a.776.776 0 0 1-.227-.037c.1.325.4.566.756.566h8.733a.796.796 0 0 0 .792-.793V1.322a.795.795 0 0 0-.566-.756z"
          data-original="#ff7f29"
        />
        <g fill="#e4eff8">
          <path
            d="M4.232.53v2.91c0 .204.222.331.399.228l1.059-.61 1.058.61a.265.265 0 0 0 .397-.228V.53zM10.847 5.557c-1.312 0-2.38 1.069-2.38 2.38s1.068 2.381 2.38 2.381c1.312 0 2.382-1.069 2.382-2.38s-1.07-2.381-2.382-2.381zM1.852 8.202c0 .354.53.354.53 0V6.88c0-.353-.53-.353-.53 0zM2.91 8.202c0 .354.53.354.53 0V6.88c0-.353-.53-.353-.53 0zM3.969 8.202c-.001.354.53.354.529 0V6.88c0-.353-.53-.353-.53 0z"
            fill="#e4eff8"
            data-original="#e4eff8"
          />
        </g>

        <path
          fill="#c4dcf0"
          d="M6.616.53v2.91c0 .049-.014.093-.036.131l.168.097a.265.265 0 0 0 .397-.228V.53z"
          data-original="#c4dcf0"
        />
        <path
          fill="#c4dcf0"
          d="m5.69 2.53-1.06.609a.265.265 0 0 1-.398-.229v.53c0 .204.222.331.399.228l1.059-.61 1.058.61a.265.265 0 0 0 .397-.228v-.53c0 .204-.221.33-.397.229z"
          data-original="#c4dcf0"
        />
      </g>
      <g transform="matrix(.057000000000000007,0,0,.0570000000000007,-5,8)">
        <path
          fill="#7397b8"
          d="M471.083 31.867 415.888 0c-9.093 15.749-25.005 23.624-40.917 23.624l-60 110.981 60 110.981c15.912 0 31.824 7.874 40.917 23.623l55.196-31.867c-18.185-31.498 4.546-70.87 40.917-70.87v-63.734c-36.372-.001-59.103-39.373-40.918-70.871z"
          data-original="#7397b8"
        />
        <path
          fill="#8db3cf"
          d="m334.054 0-55.196 31.867c18.185 31.498-4.546 70.87-40.917 70.87v63.734c36.371 0 59.102 39.372 40.917 70.87l55.196 31.867c9.093-15.749 25.005-23.623 40.917-23.623V23.624c-15.912 0-31.824-7.875-40.917-23.624z"
          data-original="#8db3cf"
        />
        <path
          fill="#435d7a"
          d="M422.24 134.604c0 26.106-21.163 47.27-47.27 47.27l-23.635-47.27 23.635-47.269c26.107 0 47.27 21.163 47.27 47.269z"
          data-original="#435d7a"
        />
        <path
          fill="#7397b8"
          d="M374.971 87.335v94.539c-26.106 0-47.27-21.163-47.27-47.27s21.164-47.269 47.27-47.269z"
          data-original="#7397b8"
        />
      </g>
    </svg>
  );
}

export default AutomaticOrder;
